<template>
  <div id="content-page">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-2 pb-4">
          <router-link :to="{ name: 'imports.create' }">
            <b-button block variant="primary" outline size="lg">
              <i class="fas fa-plus"></i>
              Add
            </b-button>
          </router-link>
        </div>
      </div>
      <div class="row">
        <b-col>
          <iq-card>
            <template v-slot:body class="pt-0">
              <b-row>
                <b-col>
                  <b-row>
                    <b-col>
                      <h4 class="card-title">Search by</h4>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-form-group class="mb-0">
                        <b-form-input
                          id="exampleInputText1"
                          type="text"
                          placeholder="enter name"
                          size="sm"
                          v-model="search"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </template>
          </iq-card>
        </b-col>
      </div>
      <div class="row">
        <b-col>
          <iq-card>
            <template v-slot:body>
              <b-table
                hover
                responsive
                :items="items"
                :fields="fields"
                class="mb-0 table-borderless"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :busy="loading"
                sort-icon-left
              >
                <template #table-busy>
                  <div class="text-center p-4" style="color: var(--iq-primary)">
                    <b-spinner class="align-middle mr-3"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                </template>
                <template v-slot:cell(name)="data">
                  <router-link
                    :to="{
                      path: `/imports/${data.item.id}/detail`,
                    }"
                  >
                    <b-button variant="link" style="color: var(--iq-primary)">
                      {{ data.item.name }}
                    </b-button>
                  </router-link>
                </template>
                <template v-slot:cell(list_name)="data">{{
                  data.item.list_name
                }}</template>
                <template v-slot:cell(progress)="data"
                  >{{ data.value * 100 }} %</template
                >

                <template v-slot:cell(created_at)="data">
                  <h6>{{ data.value | formatDate }}</h6>
                </template>
              </b-table>
            </template>
          </iq-card>
        </b-col>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* .row-shadow {
  transition: 0.2s;
}
.row-shadow:hover {
  transition: 0.2s;
  scale: 1.15;
  transform: scale(1.03);
  cursor: pointer;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
} */
</style>
<script>
import { core } from "../../config/pluginInit";
import gql from "graphql-tag";
const LIST_IMPORTS = gql`
  query listImports(
    $where: data_imports_bool_exp!
    $order_by: [data_imports_order_by!]
    $limit: Int!
    $offset: Int!
  ) {
    data_imports_aggregate(order_by: $order_by, where: $where) {
      aggregate {
        totalCount: count
      }
    }
    data_imports(
      limit: $limit
      offset: $offset
      order_by: $order_by
      where: $where
    ) {
      id
      name
      list_name
      progress
      number_of_imported
      number_of_errors
      created_at
      error
    }
  }
`;
export default {
  name: "Imports",
  data() {
    return {
      sortBy: "created_at",
      sortDesc: false,
      dataImports: [],
      search: "",
      rows: null,
      perPage: 25,
      currentPage: 1,
      error: false,
      loading: false,
      fields: [
        { key: "name", title: "Import Name", sortable: true },
        { key: "list_name", title: "List name", sortable: true },
        { key: "progress", title: "Progress", sortable: true },
        { key: "error", title: "Import error", sortable: false },
        { key: "number_of_imported", title: "Imported lines", sortable: true },
        { key: "number_of_errors", title: "Error lines", sortable: true },
        { key: "created_at", title: "Created at", sortable: true }
      ],
      toDeleteItem: null
    };
  },
  apollo: {
    dataImports: {
      query: LIST_IMPORTS,
      fetchPolicy: "no-cache",
      variables() {
        const vars = {
          where: {},
          // pagination
          limit: this.perPage,
          offset: this.currentPage * this.perPage - this.perPage
        };

        // sorting
        if (this.sortBy !== "") {
          vars.order_by = {
            [this.sortBy]: this.sortDesc ? "desc" : "asc"
          };
        }

        // filter
        const whereAttributes = [];
        if (this.search) {
          whereAttributes.push({
            list_name: {
              _ilike: `%${this.search}%`
            }
          });
        }
        if (whereAttributes.length > 0) {
          vars.where = {
            _and: whereAttributes
          };
        }

        return vars;
      },
      update: data => {
        return data.data_imports.map(i => {
          return {
            id: i.id,
            name: i.name,
            list_name: i.list_name,
            progress: i.progress,
            number_of_imported: i.number_of_imported,
            number_of_errors: i.number_of_errors,
            created_at: i.created_at,
            error: i.error
          };
        });
      },

      result({ data, loading, networkStatus }) {
        if (!loading) {
          this.rows = data.data_imports_aggregate.aggregate.totalCount;
        }
      }
    }
  },
  computed: {
    items() {
      const d = this.dataImports.map(di => {
        return {
          id: di.id,
          name: di.name,
          list_name: di.list_name,
          progress: di.progress,
          number_of_imported: di.number_of_imported,
          number_of_errors: di.number_of_errors,
          created_at: di.created_at,
          error: di.error
        };
      });
      return d;
    }
  },
  mounted() {
    core.index();
  }
};
</script>
